import {
  faCalendarPlus,
  faCheck,
  faDotCircle,
  faEdit,
  faEye,
  faPaperPlane
} from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography, useTheme } from "@mui/material"
import { FC } from "react"
import {
  ActionIconButtonProps,
  ActionIconButtonTypeEnum,
  CustomActionIconProps
} from "./actionIcon.interface"
import { StyledActionIconButton } from "./actionIconButton.styled"
import { useTranslation } from "react-i18next"
import { faBell } from "@fortawesome/pro-light-svg-icons"

const ActionButtonIcon: FC<ActionIconButtonProps> = ({ type, iconSize, custom, handleOnClick }) => {
  const { icon, label, color } = custom
    ? custom
    : ({ icon: faDotCircle, label: "", color: "secondary" } as CustomActionIconProps)
  const { t } = useTranslation()
  const theme = useTheme()

  switch (type) {
    case ActionIconButtonTypeEnum.Book:
      return (
        <StyledActionIconButton
          color="secondary"
          size="large"
          onClick={(event) => {
            event.stopPropagation()
            handleOnClick()
          }}>
          <FontAwesomeIcon icon={faCalendarPlus} size="xs" />
          <Typography>{t("global.book", "Book")}</Typography>
        </StyledActionIconButton>
      )
    case ActionIconButtonTypeEnum.Edit:
      return (
        <StyledActionIconButton
          color="secondary"
          size="large"
          onClick={(event) => {
            event.stopPropagation()
            handleOnClick()
          }}>
          <FontAwesomeIcon icon={faEdit} size="xs" />
          <Typography>{t("global.change", "Change")}</Typography>
        </StyledActionIconButton>
      )
    case ActionIconButtonTypeEnum.View:
      return (
        <StyledActionIconButton
          color="secondary"
          size="large"
          onClick={(event) => {
            event.stopPropagation()
            handleOnClick()
          }}>
          <FontAwesomeIcon icon={faEye} color={theme.palette.secondary.main} size="xs" />
          <Typography>{t("global.show", "Show")}</Typography>
        </StyledActionIconButton>
      )
    case ActionIconButtonTypeEnum.Approve:
      return (
        <StyledActionIconButton
          color="secondary"
          size="large"
          onClick={(event) => {
            event.stopPropagation()
            handleOnClick()
          }}>
          <FontAwesomeIcon icon={faCheck} size="xs" />
          <Typography>{t("global.approve", "Approve")}</Typography>
        </StyledActionIconButton>
      )
    case ActionIconButtonTypeEnum.SendNotification:
      return (
        <StyledActionIconButton
          color="secondary"
          size="large"
          onClick={(event) => {
            event.stopPropagation()
            handleOnClick()
          }}>
          <FontAwesomeIcon icon={faBell} size="xs" />
          <Typography ml={1} fontWeight="600" variant="bodyMedium">{t("learning.titles.send_reminder", "Send reminder")}</Typography>
        </StyledActionIconButton>
      )
    case ActionIconButtonTypeEnum.Custom:
      return (
        <StyledActionIconButton
          color={color}
          size="large"
          onClick={(event) => {
            event.stopPropagation()
            handleOnClick()
          }}>
          <FontAwesomeIcon icon={icon} size="xs" />
          <Typography>{label}</Typography>
        </StyledActionIconButton>
      )
    default:
      return (
        <StyledActionIconButton
          color={color}
          size="large"
          onClick={(event) => {
            event.stopPropagation()
            handleOnClick()
          }}>
          <FontAwesomeIcon icon={faPaperPlane} size="xs" />
          <Typography>{label}</Typography>
        </StyledActionIconButton>
      )
  }
}

export default ActionButtonIcon
